export default __webpack_public_path__ + "static/media/autoCareLogo_fr.325eb070.png";